import ResetPWDExpired from './ResetPWDExpired'

export default ResetPWDExpired
